import { Component, inject, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { DEFAULT_POPUP_CONFIG, DroplistWidget } from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { AppService, TrimesterService } from '../../../services';

@Component({
	selector: 'trimester-droplist',
	standalone: true,
	templateUrl: './trimester-droplist.widget.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [DroplistWidget]
})
export class TrimesterDroplistWidget implements OnInit {

	public readonly popupConfig = DEFAULT_POPUP_CONFIG;
	private appService = inject(AppService);
	public service = inject(TrimesterService);
	public trimesterWindow = input.required<TrimesterWindowEnum>();

	constructor() {
		toObservable(this.appService.data).subscribe(async data => {
			if (data.trimesters.length > 0) {
				await this.service.loadData(this.trimesterWindow());
			}
		})
	}

	async ngOnInit() {
		await this.service.loadData(this.trimesterWindow());
	}
}